.selfAssessmentMarking {
  position: relative;

  &:before {
    position: absolute;
    content: "";
    border: 3px solid var(--mantine-color-zli-orange-8);
    border-radius: 50%;
    inset: -4px;
  }
}
